import React, { Component } from 'react';
import { warehouseOR } from '../../constants/warehouseCode';

class Tour extends Component {
  state = {
    tour: {
      active: "",
      class: "",
      heading: "",
      content: "",
      prev: "",
      next: "",
    }
  }
  componentWillMount() {
    localStorage.Tour === "true" && localStorage.TourFinish === "false" ?
      this.setState({
        tour: {
          active: "address",
          class: "take tour1",
          heading: "Your Shipping Address",
          content: `Use this as your delivery address when you checkout from ${warehouseOR} online stores. Don't forget to input your complete ShippingCart address, including your account number and phone number when you checkout!`,
          prev: null,
          next: "cart",
        }
      })
      : this.setState({ tour:{active: null} });
    localStorage.removeItem('Tour');
  }

  handleTour(step) {
    switch (step) {
      case "address":
        this.setState({
          tour: {
            active: "address",
            class: "take tour1",
            heading: "Your Shipping Address",
            content: `Use this as your delivery address when you checkout from ${warehouseOR} online stores. Don't forget to input your complete ShippingCart address, including your account number and phone number when you checkout!`,
            prev: null,
            next: "cart",
          }
        });
        break;
      case "cart":
        this.setState({ tour: {
          active: "cart",
          class: "take tour2",
          heading: "Cart",
          content: `This is where you can view your purchases from ${warehouseOR} online stores once they arrive to the ShippingCart Warehouse. All the information you need is here, including photos. Ship them out when you're ready!`,
          prev: "address",
          next: "shipments",
        }});
        break;
      case "shipments":
        this.setState({ tour: {
          active: "shipments",
          class: "take tour3",
          heading: "Shipments",
          content: "This is where you can view your shipping history, whether it's paid, in transit, or delivered. This is where you can track your shipment status, as your tracking number appears here once your shipment status is in transit.",
          prev: "cart",
          next: "account",
        }});
        break;
      case "account":
        this.setState({ tour: {
          active: "account",
          class: "take tour4",
          heading: "Account",
          content: "This is all about you! This is where you can manage your address book or invite friends to try out the ShippingCart service.",
          prev: "shipments",
          next: "estimate",
        }});
        break;
      case "estimate":
        this.setState({ tour: {
          active: "estimate",
          class: "take tour5",
          heading: "Get Shipping Estimate",
          content: "You'll need your item's dimensions, so you can calculate your cost on the ShippingCart Cost Calculator. Note that this is only an estimate.",
          prev: "account",
          next: "track",
        }});
        break;
      case "track":
        this.setState({ tour: {
          active: "track",
          class: "take tour6",
          heading: "Track Your Package",
          content: `Find out where your package is exactly using the tracking number we provided. Note that this is different from the tracking number provided to you by the ${warehouseOR} online store you purchased from.`,
          prev: "estimate",
          next: null,
        }});
        break;
      default:
    }
  }
  cancelTour = () => {
    this.setState({
      tour: {
        active: null
      }
    });
    localStorage.setItem("TourFinish", "true");
  }

  render() {
    const tour = this.state.tour;
    return (
      <div>
        <div className={ tour.active ? "modal-backdrop in" : "disnone"}> </div>
        {
          tour.active ?
            <div className={tour.class}>
              <span className="heading">{ tour.heading }</span> <hr />
              <p>{ tour.content }</p>
                <span className="pull-right">
                {
                  tour.prev === null ? null :
                    <div><span><i className="fa fa-angle-left"></i></span><a className="previous" onClick={() => this.handleTour(tour.prev)}>Previous</a></div>
                }
                {
                  tour.next === null ?
                  <a className="done" onClick={this.cancelTour}>Done</a>
                  : <div><a className="next" onClick={() => this.handleTour(tour.next)}>Next</a><span><i className="fa fa-angle-right"></i></span></div>
                }
                </span>
              { tour.next === null ? null :
                <div className="skip-wrapper">
                  <a className="skiptour pull-right" onClick={this.cancelTour}><span><i className="fa fa-close skip-icon"></i></span>Skip the tour</a>
                </div>
              }
            </div>
          : null
        }
      </div>
    )
  }
}


export default Tour



/** WEBPACK FOOTER **
 ** ./src/components/DashboardFiles/Tour.js
 **/